module.exports = __webpack_public_path__ + "img/image_trade_contract.d39ed29f.svg";